'use client';

import { ChevronLeft } from '@/components/icons/ChevronLeft';
import { useWizardNavigation } from '../hooks/useWizardNavigation';

interface WizardMobileBackButtonProps {
  dark?: boolean;
}

/**
 * Mobile-only back button displayed at the top of step content.
 *
 * Hidden on desktop where Back/Continue are side-by-side at the bottom.
 * Returns null on the first step (no previous step to navigate to).
 * Use `dark` for steps with dark backgrounds (e.g. LocationCheckStep).
 */
export function WizardMobileBackButton({
  dark = false,
}: WizardMobileBackButtonProps) {
  const { hasPreviousStep, goToPreviousStep } = useWizardNavigation();

  if (!hasPreviousStep) return null;

  return (
    <div className='flex w-full items-start pb-6 md:hidden'>
      <button
        type='button'
        onClick={goToPreviousStep}
        className={`flex items-center gap-2 px-4 py-3 text-lg ${dark ? 'text-white' : 'text-[#292722]'}`}
      >
        <ChevronLeft className='h-[18px] w-[10px]' />
        Back
      </button>
    </div>
  );
}
